import React, { useState , useEffect} from "react";
import { TextField, Button, Dialog } from "@mui/material";
import {AppCTX} from '../data/AppContext'
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { storage } from '../firebase-config'
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import MyLocationIcon from '@mui/icons-material/MyLocation';
import IconButton from '@mui/material/IconButton';


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function AddProspect() {
  const { 
    addProspect, 
    user, 
    openAddProspect, 
    setOpenAddProspect, 
    newProspect, 
    setNewProspect,
    addAddress
  } = React.useContext(AppCTX);

  const [name, setName]=useState('')
  const [nameError, setNameError] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('+1')
  const [numberError, setNumberError] = useState('');
  const [notes, setNotes] = useState('')
  const [notesError, setNotesError] = useState('');
  const [step, setStep] = useState(1);
  // const [hopBackTime, setHopBacktime] = useState('07:00');
  // const [scheduleHopBack, setHopBack] = useState(false)

  useEffect(() => {
    console.log('newProspect from Lead capture', newProspect)
  },[newProspect])

  useEffect(() => {
    console.log('coooooordinates',newProspect.coords)
    if(!openAddProspect && newProspect.coords!=null){
      setNewProspect({
        owners:[],
        notes:[],
        utilityBill:null,
        coords: false,
        address:'',
        setter:'',
        closer:'',
        systemInstalled: false,
        appointmentStart:null,
        appointmentSet:false,
      })
      setName('')
      setNameError('')
      setPhoneNumber('+1')
      setNumberError('')
      setNotes('')
      setNotesError('')
      setStep(1)
    }else if (newProspect.coords){
      console.log('coooooordinates',newProspect.coords)
      addAddress()
    }
  },[openAddProspect])


  const handleNameChange = (e) => {
    if(nameError.length>0&&e.target.value.length>1) setNameError('')
    setName(e.target.value);
  };

  const handleNumberChange = (e) => {
    if(e.target.value.length<2)return
    if(isNaN(e.target.value))return
    if(numberError.length>0&&e.target.value.length>2) setNumberError('')
    if(e.target.value.length<=12){
      setPhoneNumber(e.target.value);
    }
  };

  const handleNotesChange = (e) => {
    if(notesError.length>0&&e.target.value.length>1) setNotesError('')
    setNotes(e.target.value)
  };

  const addOwner = (next) => {
    if(name.length===0){
      setNameError("Enter name")
      return
    }
    if(phoneNumber.length<12){
      setNumberError("Enter a valid phone number")
      return
    }
    let update = {
      ...newProspect,
      coords: {
        lat: newProspect.coords.lat,
        lng: newProspect.coords.lng
      },
      owners:newProspect.owners
    }
    update.owners.push({
      name:name,
      number:phoneNumber
    })
    setNewProspect(update);
    if(next==='add'){
      setName('')
      setPhoneNumber('+1')
      setStep(2)
    }
    if(next==='skip'){
      setStep(3)
    }
  }

  const uploadUtilityBill = async (e) => {
    try{
      const electricityBillRef = ref(storage, 'electricity-bills/'+newProspect.address+'.jpg');
      let result = await uploadBytes(electricityBillRef, e.target.files[0])
      let url = await getDownloadURL(ref(storage, result.ref.fullPath))
      let update = {...newProspect, utilityBill: url}
      setNewProspect(update);
      setStep(4)
    }catch(err){
      console.error(err)
    }
  }

  const handleSubmit = () => {
    if(notes.length===0){
      setNotesError('Enter some notes')
      return
    }
    let payload = {
      ...newProspect,
      coords: {
        lat: newProspect.coords.lat,
        lng: newProspect.coords.lng
      },
      owners:newProspect.owners,
      notes:[`${user.data.name} - ${notes}`],
      setter: user.data.name
    }
    addProspect(payload)
    setOpenAddProspect(false)
  };

  const renderTitle = () => {
    if(step === 1) return("Add Homeowner")
    if(step === 2) return("Add Homeowner 2")
    if(step === 3) return("Add Utility bill")
    if(step === 4) return("Add Notes")
  }

  const renderAddProspect = () => {
    if(step===1||step===2) {
      return (
        <Stack spacing={2}>
          <TextField
            required
            className="form-field"
            label="Name"
            value={name}
            onChange={handleNameChange}
            error={nameError.length>0}
            helperText={nameError}
          />
          <TextField
            required
            className="form-field"
            label="Number"
            value={phoneNumber}
            onChange={handleNumberChange}
            error={numberError.length>0}
            helperText={numberError}
          />
          {step===2?<></>:
            <Button onClick={()=>addOwner('add')} variant="contained" color="primary">
              Add Owner 2
            </Button>
          }
          <Button onClick={()=>addOwner('skip')} variant="contained" color="primary">
            Next
          </Button>
        </Stack>
      )
    } else if(step===3) {
      return (
        <Stack spacing={2}>
          <Button component="label" variant="contained" startIcon={<CloudUploadIcon />}>
            Upload Utility bill
            <VisuallyHiddenInput onChange={uploadUtilityBill} type="file" />
          </Button>
          <Button onClick={()=>setStep(4)} variant="contained" color="primary">
            Skip
          </Button>
        </Stack>
      )
    } else if(step===4) {
      return (
        <Stack spacing={2}>
          <TextField
            label="Notes"
            className="form-field"
            value={notes}
            onChange={handleNotesChange}
            multiline
            minRows={4}
            error={notesError.length>0}
            helperText={notesError}
          />
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Save
          </Button>
        </Stack>
      )
    }
  }

  return (
    <Dialog
      open={openAddProspect}
      onClose={()=>setOpenAddProspect(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className="alertModalTitle">
        {renderTitle()}
      </DialogTitle>
      <DialogContent>
        {renderAddProspect()}
      </DialogContent>
      <DialogActions className='alertBottomBorder'>
        <div className='alertModalButton'>
          <Button onClick={()=>setOpenAddProspect(false)} autoFocus>
            Close
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default AddProspect;
